export default __webpack_public_path__ + "static/media/playstore.64cbdfaf.webp";